import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FireworksBackground from "../components/FireworksBackground";
import "./Home.css";
import { MdDoubleArrow } from "react-icons/md";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import rollerCoasterVideo from "../assets/video/roller-coaster-video.mp4";
import "@fortawesome/fontawesome-free/css/all.css";
import control from "../assets/image/home_2_ctrl.png";
import safety from "../assets/image/home_2_safety.png";
import information from "../assets/image/home_2_Information.png";
import h3_1 from "../assets/image/home_3_1.png";
import h3_2 from "../assets/image/home_3_2.png";
import h3_3 from "../assets/image/home_3_3.png";
import h3_4 from "../assets/image/home_3_4.png";
import h3_5 from "../assets/image/home_3_5.png";
import h3_6 from "../assets/image/home_3_6.png";
import h4_1 from "../assets/image/home_4_1.png";
import h4_2 from "../assets/image/home_4_2.png";
import h4_3 from "../assets/image/home_4_3.png";
import Home1bg from "../assets/image/home_1_bg.png";

function Home() {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
      engine.addPreset("custom-effect", options1);
      setInit(true);
    });
  }, []);

  const particlesLoaded = (container) => {};

  const options1 = {
    autoPlay: true,
    background: {
      color: {
        value: "#659f4c",
      },
      image: "",
      position: "",
      repeat: "",
      size: "",
      opacity: 1,
    },
    backgroundMask: {
      composite: "destination-out",
      cover: {
        opacity: 1,
        color: {
          value: "",
        },
      },
      enable: false,
      clear: true,
    },
    defaultThemes: {},
    delay: 0,
    fullScreen: {
      enable: false,
      zIndex: 0,
    },
    detectRetina: true,
    duration: 0,
    fpsLimit: 120,
    interactivity: {
      detectsOn: "window",
      events: {
        onClick: {
          enable: true,
          mode: "push",
        },
        onDiv: {
          selectors: {},
          enable: false,
          mode: {},
          type: "circle",
        },
        onHover: {
          enable: true,
          mode: "grab",
          parallax: {
            enable: true,
            force: 60,
            smooth: 10,
          },
        },
        resize: {
          delay: 0.5,
          enable: true,
        },
      },
      modes: {
        trail: {
          delay: 1,
          pauseOnStop: false,
          quantity: 1,
        },
        attract: {
          distance: 200,
          duration: 0.4,
          easing: "ease-out-quad",
          factor: 1,
          maxSpeed: 50,
          speed: 1,
        },
        bounce: {
          distance: 200,
        },
        bubble: {
          distance: 400,
          duration: 2,
          mix: false,
          opacity: 0.8,
          size: 40,
        },
        connect: {
          distance: 80,
          links: {
            opacity: 0.5,
          },
          radius: 60,
        },
        grab: {
          distance: 400,
          links: {
            blink: false,
            consent: false,
            opacity: 1,
          },
        },
        push: {
          default: true,
          groups: [],
          quantity: 4,
        },
        remove: {
          quantity: 2,
        },
        repulse: {
          distance: 200,
          duration: 0.4,
          factor: 100,
          speed: 1,
          maxSpeed: 50,
          easing: "ease-out-quad",
        },
        slow: {
          factor: 3,
          radius: 200,
        },
        light: {
          area: {
            gradient: {
              start: {
                value: "#ffffff",
              },
              stop: {
                value: "#000000",
              },
            },
            radius: 1000,
          },
          shadow: {
            color: {
              value: "#000000",
            },
            length: 2000,
          },
        },
      },
    },
    particles: {
      bounce: {
        horizontal: {
          value: 1,
        },
        vertical: {
          value: 1,
        },
      },
      collisions: {
        absorb: {
          speed: 2,
        },
        bounce: {
          horizontal: {
            value: 1,
          },
          vertical: {
            value: 1,
          },
        },
        enable: false,
        maxSpeed: 50,
        mode: "bounce",
        overlap: {
          enable: true,
          retries: 0,
        },
      },
      color: {
        value: "#ffffff",
      },
      move: {
        angle: {
          offset: 0,
          value: 90,
        },
        attract: {
          distance: 200,
          enable: false,
          rotate: {
            x: 3000,
            y: 3000,
          },
        },
        center: {
          x: 50,
          y: 50,
          mode: "percent",
          radius: 0,
        },
        decay: 0,
        direction: "none",
        drift: 0,
        enable: true,
        gravity: {
          acceleration: 9.81,
          enable: false,
          inverse: false,
          maxSpeed: 50,
        },
        path: {
          clamp: true,
          delay: {
            value: 0,
          },
          enable: false,
          options: {},
        },
        outModes: {
          default: "out",
          bottom: "out",
          left: "out",
          right: "out",
          top: "out",
        },
        random: false,
        size: false,
        speed: 2,
        spin: {
          acceleration: 0,
          enable: false,
        },
        straight: false,
        trail: {
          enable: false,
          length: 10,
          fill: {},
        },
        vibrate: false,
        warp: false,
      },
      number: {
        density: {
          enable: true,
          width: 3840,
          height: 2140,
        },
        limit: {
          mode: "delete",
          value: 200,
        },
        value: 100,
      },
      opacity: {
        value: {
          min: 0.1,
          max: 0.5,
        },
        animation: {
          count: 0,
          enable: true,
          speed: 3,
          decay: 0,
          delay: 0,
          sync: false,
          mode: "auto",
          startValue: "random",
          destroy: "none",
        },
      },
      shape: {
        close: true,
        fill: true,
        options: {},
        type: "circle",
      },
      size: {
        value: {
          min: 1,
          max: 10,
        },
        animation: {
          count: 0,
          enable: true,
          speed: 20,
          decay: 0,
          delay: 0,
          sync: false,
          mode: "auto",
          startValue: "random",
          destroy: "none",
        },
      },
      zIndex: {
        value: 0,
        opacityRate: 1,
        sizeRate: 1,
        velocityRate: 1,
      },
      destroy: {
        bounds: {},
        mode: "none",
        split: {
          count: 1,
          factor: {
            value: 3,
          },
          rate: {
            value: {
              min: 4,
              max: 9,
            },
          },
          sizeOffset: true,
          particles: {},
        },
      },
      roll: {
        darken: {
          enable: false,
          value: 0,
        },
        enable: false,
        enlighten: {
          enable: false,
          value: 0,
        },
        mode: "vertical",
        speed: 25,
      },
      twinkle: {
        lines: {
          enable: false,
          frequency: 0.05,
          opacity: 1,
        },
        particles: {
          enable: false,
          frequency: 0.05,
          opacity: 1,
        },
      },
    },
    pauseOnBlur: true,
    pauseOnOutsideViewport: true,
    responsive: [],
    smooth: false,
    style: {},
    themes: [],
    zLayers: 100,
    motion: {
      disable: false,
      reduce: {
        factor: 4,
        value: true,
      },
    },
  };

  const options2 = {
    autoPlay: true,
    background: {
      color: {
        value: "#27506e",
      },
      image: "",
      position: "50% 50%",
      repeat: "no-repeat",
      size: "cover",
      opacity: 1,
      backgroundMask: {
        composite: "destination-out",
        cover: {
          opacity: 1,
          color: {
            value: "",
          },
        },
        enable: false,
      },
    },
    clear: true,
    defaultThemes: {},
    delay: 0,
    fullScreen: {
      enable: false,
      zIndex: 0,
    },
    detectRetina: true,
    duration: 0,
    fpsLimit: 120,
    interactivity: {
      detectsOn: "window",
      events: {
        onClick: {
          enable: true,
          mode: "push",
        },
        onDiv: {
          selectors: {},
          enable: false,
          mode: {},
          type: "circle",
        },
        onHover: {
          enable: true,
          mode: "repulse",
          parallax: {
            enable: false,
            force: 2,
            smooth: 10,
          },
        },
        resize: {
          delay: 0.5,
          enable: true,
        },
      },
      modes: {
        trail: {
          delay: 1,
          pauseOnStop: false,
          quantity: 1,
        },
        attract: {
          distance: 200,
          duration: 0.4,
          easing: "ease-out-quad",
          factor: 1,
          maxSpeed: 50,
          speed: 1,
        },
        bounce: {
          distance: 200,
        },
        bubble: {
          distance: 200,
          duration: 0.4,
          mix: false,
        },
        connect: {
          distance: 80,
          links: {
            opacity: 0.5,
          },
          radius: 60,
        },
        grab: {
          distance: 100,
          links: {
            blink: false,
            consent: false,
            opacity: 1,
          },
        },
        push: {
          default: true,
          groups: [],
          quantity: 4,
        },
        remove: {
          quantity: 2,
        },
        repulse: {
          distance: 200,
          duration: 0.4,
          factor: 100,
          speed: 1,
          maxSpeed: 50,
          easing: "ease-out-quad",
          divs: {
            distance: 200,
            duration: 0.4,
            factor: 100,
            speed: 1,
            maxSpeed: 50,
            easing: "ease-out-quad",
            selectors: {},
          },
        },
        slow: {
          factor: 3,
          radius: 200,
        },
        light: {
          area: {
            gradient: {
              start: {
                value: "#ffffff",
              },
              stop: {
                value: "#000000",
              },
            },
            radius: 1000,
          },
          shadow: {
            color: {
              value: "#000000",
            },
            length: 2000,
          },
        },
      },
    },
    manualParticles: [],
    particles: {
      bounce: {
        horizontal: {
          value: 1,
        },
        vertical: {
          value: 1,
        },
      },
      collisions: {
        absorb: {
          speed: 2,
        },
        bounce: {
          horizontal: {
            value: 1,
          },
          vertical: {
            value: 1,
          },
        },
        enable: false,
        maxSpeed: 50,
        mode: "bounce",
        overlap: {
          enable: true,
          retries: 0,
        },
      },
      color: {
        value: "#ffffff",
        animation: {
          h: {
            count: 0,
            enable: false,
            speed: 1,
            decay: 0,
            delay: 0,
            sync: true,
            offset: 0,
          },
          s: {
            count: 0,
            enable: false,
            speed: 1,
            decay: 0,
            delay: 0,
            sync: true,
            offset: 0,
          },
          l: {
            count: 0,
            enable: false,
            speed: 1,
            decay: 0,
            delay: 0,
            sync: true,
            offset: 0,
          },
        },
      },
      effect: {
        close: true,
        fill: true,
        options: {},
        type: {},
      },
      groups: {},
      move: {
        angle: {
          offset: 0,
          value: 90,
        },
        attract: {
          distance: 200,
          enable: false,
          rotate: {
            x: 3000,
            y: 3000,
          },
        },
        center: {
          x: 50,
          y: 50,
          mode: "percent",
          radius: 0,
        },
        decay: 0,
        distance: {},
        direction: "none",
        drift: 0,
        enable: true,
        gravity: {
          acceleration: 9.81,
          enable: false,
          inverse: false,
          maxSpeed: 50,
        },
        path: {
          clamp: true,
          delay: {
            value: 0,
          },
          enable: false,
          options: {},
        },
        outModes: {
          default: "out",
          bottom: "out",
          left: "out",
          right: "out",
          top: "out",
        },
        random: false,
        size: false,
        speed: 2,
        spin: {
          acceleration: 0,
          enable: false,
        },
        straight: false,
        trail: {
          enable: false,
          length: 10,
          fill: {},
        },
        vibrate: false,
        warp: false,
      },
      number: {
        density: {
          enable: true,
          width: 1920,
          height: 1080,
        },
        limit: {
          mode: "delete",
          value: 200,
        },
        value: 100,
      },
      opacity: {
        value: {
          min: 0.1,
          max: 0.5,
        },
        animation: {
          count: 0,
          enable: true,
          speed: 1,
          decay: 0,
          delay: 0,
          sync: false,
          mode: "auto",
          startValue: "random",
          destroy: "none",
          reduceDuplicates: false,
        },
      },
      shadow: {
        blur: 0,
        color: {
          value: "#000",
        },
        enable: false,
        offset: {
          x: 0,
          y: 0,
        },
      },
      shape: {
        type: "char",
        options: {
          char: {
            value: "",
            font: "",
            style: "solid",
            weight: "900",
          },
        },
      },
      size: {
        value: 16,
        animation: {
          count: 0,
          enable: false,
          speed: 5,
          decay: 0,
          delay: 0,
          sync: false,
          mode: "auto",
          startValue: "random",
          destroy: "none",
        },
      },
      stroke: {
        width: 1,
        color: {
          value: "#ffffff",
          animation: {
            h: {
              count: 0,
              enable: false,
              speed: 1,
              decay: 0,
              delay: 0,
              sync: true,
              offset: 0,
            },
            s: {
              count: 0,
              enable: false,
              speed: 1,
              decay: 0,
              delay: 0,
              sync: true,
              offset: 0,
            },
            l: {
              count: 0,
              enable: false,
              speed: 1,
              decay: 0,
              delay: 0,
              sync: true,
              offset: 0,
            },
          },
        },
      },
      zIndex: {
        value: 0,
        opacityRate: 1,
        sizeRate: 1,
        velocityRate: 1,
      },
      destroy: {
        bounds: {},
        mode: "none",
        split: {
          count: 1,
          factor: {
            value: 3,
          },
          rate: {
            value: {
              min: 4,
              max: 9,
            },
          },
          sizeOffset: true,
          particles: {},
        },
      },
      roll: {
        darken: {
          enable: false,
          value: 0,
        },
        enable: false,
        enlighten: {
          enable: false,
          value: 0,
        },
        mode: "vertical",
        speed: 25,
      },
      tilt: {
        value: 0,
        animation: {
          enable: false,
          speed: 0,
          decay: 0,
          sync: false,
        },
        direction: "clockwise",
        enable: false,
      },
      twinkle: {
        lines: {
          enable: false,
          frequency: 0.05,
          opacity: 1,
        },
        particles: {
          enable: false,
          frequency: 0.05,
          opacity: 1,
        },
      },
      wobble: {
        distance: 5,
        enable: false,
        speed: {
          angle: 50,
          move: 10,
        },
      },
      life: {
        count: 0,
        delay: {
          value: 0,
          sync: false,
        },
        duration: {
          value: 0,
          sync: false,
        },
      },
      rotate: {
        value: 0,
        animation: {
          enable: false,
          speed: 0,
          decay: 0,
          sync: false,
        },
        path: false,
      },
      orbit: {
        animation: {
          count: 0,
          enable: false,
          speed: 1,
          decay: 0,
          delay: 0,
          sync: false,
        },
        enable: false,
        opacity: 1,
        rotation: {
          value: 45,
        },
        width: 1,
      },
      links: {
        blink: false,
        color: {
          value: "#ffffff",
        },
        consent: false,
        distance: 150,
        enable: true,
        frequency: 1,
        opacity: 0.4,
        shadow: {
          blur: 5,
          color: {
            value: "lime",
          },
          enable: false,
        },
        triangles: {
          enable: false,
          frequency: 1,
        },
        width: 1,
        warp: false,
      },
      repulse: {
        value: 0,
        enabled: false,
        distance: 1,
        duration: 1,
        factor: 1,
        speed: 1,
      },
    },
    pauseOnBlur: true,
    pauseOnOutsideViewport: true,
    responsive: [],
    smooth: false,
    style: {},
    themes: [],
    zLayers: 100,
    key: "fontawesome",
    name: "Font Awesome",
    motion: {
      disable: false,
      reduce: {
        factor: 4,
        value: true,
      },
    },
  };

  const CUBE_FACES = [
    {
      title: "Mechanical",
      image: h3_1,
    },
    {
      title: "Forming and Padding",
      image: h3_2,
    },
    {
      title: "Netting",
      image: h3_3,
    },
    {
      title: "Electrical",
      image: h3_4,
    },
    {
      title: "Railing",
      image: h3_5,
    },
    {
      title: "Customized Parts",
      image: h3_6,
    },
  ];
  return (
    <div>
      <Helmet>
        <title>Riocube Engineering | Engineering Your Magic</title>
        <meta
          name="description"
          content="Innovating Themed Entertainment solutions through precision engineering and safety-first approaches. Explore how we engineer your magic vision into reality."
        />
        <meta name="keywords" content="" />
      </Helmet>

      <Header />

      <section
        className="hero-banner"
        style={{ backgroundImage: `url(${Home1bg})` }}
      >
        {/* <div className="video-overlay"></div>
        <video autoPlay muted loop playsInline className="background-video">
          <source src={rollerCoasterVideo} type="video/mp4" />
        </video>*/}
        <div className="overlay-1">
          <h1>
            ENGINEERING YOUR <span style={{ color: "#659f4c" }}>MAGIC</span>
          </h1>
          <h1 className="since">SINCE 2015</h1>
          <p>
            The "control, safety, and information technology" of attraction
            facilities is the basic of the company's business, expanding into
            comprehensive integration across the theme entertainment industry.
          </p>
          <p className="overlay-1-p">
            <span style={{ color: "#659f4c" }}>C</span>ontrols,{" "}
            <span style={{ color: "#E49E20" }}>A</span>nimatronics,{" "}
            <span style={{ color: "#01488C" }}>R</span>ides Service,{" "}
            <span style={{ color: "#E49E20" }}>E</span>ffects and{" "}
            <span style={{ color: "#E49E20" }}>S</span>cenic.
          </p>
          <a href="/AboutUs" className="cta-btn">
            Learn More Riocube CARES <MdDoubleArrow />
          </a>
        </div>
      </section>

      <section className="hero-banner">
        <div className="particles-container">
          {init && (
            <Particles
              id="tsparticless"
              particlesLoaded={particlesLoaded}
              options={options1}
            />
          )}
        </div>

        <div className="overlay-4">
          <h1>
            <span style={{ color: "#01488C" }}>E</span>NGINEERING &{" "}
            <span style={{ color: "#01488C" }}>S</span>AFETY
          </h1>
          <p>
            Delivering cutting-edge control, safety, and AI solutions for themed
            attractions. Ensuring precision, reliability, and compliance for
            your magical experiences.
          </p>
          <a href="/Engineering&Safety" className="cta-btn">
            Learn More <MdDoubleArrow />
          </a>
          <div className="honeycomb-container">
            <div className="hexagon">
              <div
                className="hex-content"
                style={{
                  backgroundImage: `url(${control})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <span
                  className="hex-text"
                  style={{
                    color: "#10B981",
                  }}
                >
                  Control
                </span>
              </div>
            </div>

            <div className="hexagon">
              <div
                className="hex-content"
                style={{
                  backgroundImage: `url(${safety})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <span
                  className="hex-text"
                  style={{
                    color: "#3B82F6",
                  }}
                >
                  Safety
                </span>
              </div>
            </div>

            <div className="hexagon">
              <div
                className="hex-content"
                style={{
                  backgroundImage: `url(${information})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <span
                  className="hex-text"
                  style={{
                    color: "#F59E0B",
                  }}
                >
                  Information
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hero-banner">
        <div className="particles-container">
          {init && (
            <Particles
              id="tsparticles2"
              particlesLoaded={particlesLoaded}
              options={options2}
            />
          )}
        </div>
        <div className="cube-wrapper">
          <div className="cube-container">
            {CUBE_FACES.map((face, index) => (
              <div
                className={`cube-face face-${index + 1}`}
                key={index}
                style={{ "--delay": index * 0.2 }}
              >
                <div
                  className="face-front"
                  style={{ backgroundImage: `url(${face.image})` }}
                >
                  <h3>{face.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="overlay-3">
          <h1>
            <span style={{ color: "#659f4c" }}>P</span>ARTS &{" "}
            <span style={{ color: "#659f4c" }}>S</span>ERVICES
          </h1>
          <p>
            OEM and customer parts for themed attractions. From mechanical
            components to electrical systems, we keep your magic running
            smoothly.
          </p>
          <a href="/XCube" className="cta-btn">
            Learn More <MdDoubleArrow />
          </a>
        </div>
      </section>

      <section className="hero-banner">
        <div
          className="particles-container"
          style={{ width: "100%", height: "100vh" }}
        >
          <FireworksBackground />
        </div>

        <div className="overlay-3">
          <h1>
            <span style={{ color: "#E49E20" }}>X CUBE</span>
          </h1>
          <p>
            Specializes in the design and fabrication of animated and scenic
            show sets, as well as special effects.
          </p>
          <a href="/Parts&Services" className="cta-btn">
            Learn More <MdDoubleArrow />
          </a>
          <div className="card-container">
            <div className="card-item" style={{ "--delay": 0 }}>
              <div className="card-inner">
                <img src={h4_1} alt="Animatronics" className="card-image" />
                <div className="card-content">
                  <h3>
                    <span style={{ color: "#E49E20" }}>A</span>nimatronics
                  </h3>
                </div>
              </div>
            </div>

            <div className="card-item" style={{ "--delay": 0.2 }}>
              <div className="card-inner">
                <img src={h4_2} alt="Animatronics" className="card-image" />
                <div className="card-content">
                  <h3>
                    <span style={{ color: "#E49E20" }}>E</span>ffects
                  </h3>
                </div>
              </div>
            </div>

            <div className="card-item" style={{ "--delay": 0.4 }}>
              <div className="card-inner">
                <img src={h4_3} alt="Animatronics" className="card-image" />
                <div className="card-content">
                  <h3>
                    <span style={{ color: "#E49E20" }}>S</span>cenic
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Home;
